import React from 'react'
import { renderizarCampos } from "./Campos";
import { MDBMask, MDBView } from "mdbreact";
import { useState } from "react";
import { useSortable } from "@dnd-kit/sortable";

import { faAlignJustify, faEdit, faPen, faPlus, faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CSS } from '@dnd-kit/utilities';

const getRenderer = (type) => renderizarCampos[type] || (() => <div>No se pudo renderizar el {type}</div>);
const rutaImg = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API + process.env.REACT_APP_IMAGENES

export function Field(props) {
    const { field, handleMostrarModal, index, indexPadre, id, removerChildren, editarChildren, indexPadreF, anadirHijos } = props;
    const { type, styles } = field;
    const [mostarBotones, setMostarBotones] = useState(false)
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        width: styles?.width === 0 ? '' : styles?.width ? styles?.width : '100%',
        height: styles?.height === 0 ? '' : styles?.height ? styles?.height : '100%',
        background: (type === 'menuNavegacion') && !styles?.background ? '#000000' : styles?.background,
        backgroundImage: styles.backgroundUrl && `url(${rutaImg + styles.backgroundUrl})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        paddingTop: styles?.paddingArriba,
        paddingBottom: styles?.paddingAbajo,
        paddingLeft: styles?.paddingIzquierda,
        paddingRight: styles?.paddingDerecha,
        marginTop: styles?.marginArriba,
        marginBottom: styles?.marginAbajo,
        marginLeft: styles?.marginIzquierda,
        marginRight: styles?.marginDerecha,
        borderRadius: styles?.borderRadius ? `${styles?.borderRadius}px` : ''
    };
    const Component = getRenderer(type);
    return (
        <div ref={setNodeRef} style={style} onMouseEnter={() => setMostarBotones(true)} onMouseLeave={() => setMostarBotones(false)} className={`cavas-field-items ${styles?.className}  ${mostarBotones ? 'mostrar-Botones-container' : ''} `} >
            {mostarBotones && (<div className="botones-utiles-container container-field-field-field-position">
                <div className={`botones-utiles ${type != "agregarCampos" && "boton-cabecera"}`}>
                    {type != "agregarCampos" && <button className="botones-utiles-remover" onClick={() => editarChildren({ id, type, styles })}><FontAwesomeIcon icon={faPen} size="lg" /></button>}
                    <button {...listeners} {...attributes}><FontAwesomeIcon icon={faAlignJustify} size="lg" /></button>
                    <button className="botones-utiles-remover" onClick={() => removerChildren(id)}><FontAwesomeIcon icon={faX} size="lg" /></button>
                </div>
            </div>)}

            {type === "agregarCampos" ?
                <div className='campo-agregar-componente'>
                    <div className='botonAnadir' onClick={() => handleMostrarModal(id)} >
                        <div className='botonAnadir-botonMas'>
                            +
                        </div>
                    </div>
                </div>
                :
                <div className={`${styles?.hoverDiv && 'hoverable'} ${styles?.shadows && `z-depth-${styles?.shadows}`}  `} >
                    <MDBView hover={styles?.hoverDivClaro ? styles?.hoverDivClaro : styles?.hoverDivNegro ? styles?.hoverDivNegro : styles?.hoverDivMorado ? styles?.hoverDivMorado : false} zoom={styles?.zoom}>
                        <Component {...field} />
                        {styles?.hoverDivClaro && <MDBMask className="flex-center" overlay="white-light" />}
                        {styles?.hoverDivNegro && <MDBMask className="flex-center" overlay="stylish-light" />}
                        {styles?.hoverDivMorado && <MDBMask className="flex-center" overlay="purple-light" />}
                    </MDBView>

                </div>
            }

        </div >
    )
}
